import './utils/slider';

import jQuery from 'jquery';

window.jQuery = jQuery;
window.$ = jQuery;

(function ($) {
    $('ul.tabs__caption').on('click', 'li:not(.active)', function() {
        $(this)
            .addClass('active').siblings().removeClass('active')
            .closest('div.tabs').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
    });

    $('.accordion__title').on('click', function () {
        $(this).toggleClass('active').closest('.accordion').find('.accordion__info').slideToggle();
    })

    // pop-up

    $(".pop-up--close").on('click', function(e) {
        popUpClose();
    });

    $(".activePopUpForm").on('click', function(e) {
        e.preventDefault();
        popUpActive();
        $(".pop-up--form").addClass("active");
    });
    function popUpActive() {
        $('body').addClass("pop-up-active");
        $('.pop-ups-wrap').addClass("active");
    };

    function popUpClose() {
        $('body').removeClass("pop-up-active");
        $('.pop-ups-wrap').removeClass("active");
        $('.pop-up').removeClass("active");
    };

    $(document).on('mouseup', function (event) {
        let modal = $(".pop-up--form");

        if (!modal.is(event.target) &&
            modal.has(event.target).length === 0) {
            popUpClose();
        }
    });

    $('.pop-up__form').submit(function(e){
        let name = $('.form_name').val();
        let email = $('.form_email').val();
        let phone = $('.form_phone').val();
        console.log(name);
        console.log(email);
        console.log(phone);
        e.preventDefault();
        let formData = $(this).serialize();
        formData += '&action=my_form_action';
        console.log(formData);
        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: formData,
            beforeSend: function() {
                console.log('START Sending');
            },
            success: function(response) {
                console.log('success Sending');
                console.log('DONE');
            },
            error: function(xhr, status, error) {
                console.log('Send: ' + error );
            }
        });
        $('.pop-up__form')[0].reset();
        $('.pop-ups-wrap').removeClass('active');
    });

    $(document).ready(function() {
        let lastAnchor = ''; // Stores the last checked anchor

        // Function to activate accordion based on the current hash
        function activateAccordion(anchor) {
            if (anchor) {
                // Find the accordion by the anchor ID
                const $accordion = $('#' + anchor);

                if ($accordion.length) {
                    const $header = $accordion.find('.accordion__header');
                    const $content = $accordion.find('.accordion__content');

                    if ($header.length && $content.length) {
                        console.log("Accordion found, activating...");
                        // Activate the accordion and display content
                        $header.addClass('active');
                        $content.stop(true, true).slideDown();
                    }
                }
            }
        }

        // Function to check if the anchor in the URL has changed
        function checkAnchor() {
            const currentAnchor = window.location.hash.substring(1); // Get the anchor from the URL without '#'

            if (currentAnchor && currentAnchor !== lastAnchor) {
                lastAnchor = currentAnchor; // Update lastAnchor
                activateAccordion(currentAnchor); // Activate the accordion for the current anchor
            }
        }

        // Listen for hash changes and check anchor on page load
        $(window).on('hashchange', function() {
            lastAnchor = ''; // Reset lastAnchor to ensure checkAnchor triggers
            checkAnchor();
        });

        // Initial check in case the page loads with a hash
        checkAnchor();

        // Fallback check every second if hashchange isn't reliable
        setInterval(checkAnchor, 1000);
    });
})(window.jQuery);